export default "__VITE_ASSET__DNKabf_a__"